import { render } from "./IntergovExpensesView.vue?vue&type=template&id=4e9fec81&scoped=true"
import script from "./IntergovExpensesView.vue?vue&type=script&lang=js"
export * from "./IntergovExpensesView.vue?vue&type=script&lang=js"

import "./IntergovExpensesView.vue?vue&type=style&index=0&id=4e9fec81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9fec81"]])

export default __exports__